<app-navigation-layout [hideHeader]='true' [hideNavigation]="hideNavigation" [hideMenu]="!showBasket">
  <span main-container>
    <app-partner-code-login #partnerCodeLogin (back)="onBack()" (next)="onNext()"
      (authorizationAsGuest)="authorizationAsGuest()" [allowGuestAuthorization]='allowGuestSale'
      (navigationVisibilityChange)="onNavigationVisibilityChange(partnerCodeLogin.showNavigationBack)">
    </app-partner-code-login>
  </span>
  <span menu-container>
    <app-basket-simple-view></app-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBack()" [hideNext]="true">
    </app-backward-forward>
  </span>
</app-navigation-layout>
